// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mOiR","placeholdersHeader":"styles_placeholdersHeader__1O0kF","editorStyle":"styles_editorStyle__RhCAG","placeholdersBox":"styles_placeholdersBox__2XZfT"};